import {store} from '@/store/store.js'

export default (to, from, next) => {
  next()
  /*if (store.getters.user) { //???? undefined
    next()
  } else {
    next('/login')
  }*/
}